<template>
  <instructions-component
    class="pointer-events-auto midder"
    :header="$t('instructions')"
    :button-text="$t('continue')"
    :cards="getInstructions"
    show-button
    @button-click="closeInstructions"
  />
</template>

<script lang="ts">
import { Instructions } from '@powerplay/core-minigames-ui-ssm'
import {
  CorePhases,
  corePhasesManager,
  modes,
  requestManager,
  tutorialManager
} from '@powerplay/core-minigames'
import { pathAssetsJavelin } from '@/globals/globalvariables'

import { defineComponent } from 'vue'
import { blurState } from '@/stores'

export default defineComponent({
  name: 'InstructionComponent',
  components: {
    InstructionsComponent: Instructions
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close-instructions'],
  computed: {
    getInstructions() {

      blurState().isActive = true

      if (modes.isTrainingMode()) {

        return [
          {
            imgSrc: `${pathAssetsJavelin}/ui/instructions/training-1.png`,
            header: this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell1Title`),
            text: [this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell1Text1`)]
          },
          {
            imgSrc: `${pathAssetsJavelin}/ui/instructions/training-2.png`,
            header: this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell2Title`),
            text: [this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell2Text1`)]
          },
          {
            imgSrc: `${pathAssetsJavelin}/ui/instructions/training-3.png`,
            header: this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell3Title`),
            text: [
              this.isMobile ?
                this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell3Text1M`) :
                this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell3Text1D`)
            ]
          },
          {
            imgSrc: `${pathAssetsJavelin}/ui/instructions/training-4.png`,
            header: this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell4Title`),
            text: [this.$t(`instructionsDisciplineTraining${requestManager.disciplineID}Cell4Text1`)]
          }
        ]

      }

      const mobileSufix = this.isMobile ? 'Mobile' : ''

      return [
        {
          imgSrc: `${pathAssetsJavelin}/ui/instructions/instructions-1.png`,
          header: this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell1Title`),
          text: [
            this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell1Text1`),
            this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell1Text2`)
          ]
        },
        {
          imgSrc: `${pathAssetsJavelin}/ui/instructions/instructions-2.png`,
          header: this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell2Title`),
          text: [
            this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell2Text1`),
            this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell2Text2`)
          ]
        },
        {
          imgSrc: `${pathAssetsJavelin}/ui/instructions/instructions-3.png`,
          header: this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell3Title`),
          text: [this.$t(`instructionsDiscipline${requestManager.disciplineID}Cell3Text1${mobileSufix}`)]
        },
      ]

    }
  },
  methods: {
    closeInstructions(): void {

      // pokial mame prvotne instrukcie, tak ich zavrieme
      if (corePhasesManager.isActivePhaseByType(CorePhases.instructions)) {

        corePhasesManager.getActualPhase()?.finishPhase()

      }
      this.$emit('close-instructions')
      tutorialManager.blockInputsManually()

    }
  }
})
</script>

<style lang="less" scoped>
</style>
